import React from "react";

const url =
  "https://st.depositphotos.com/1004605/1379/i/950/depositphotos_13791269-stock-photo-golden-retriever.jpg";
const Avatar = ({ className }) => {
  return <img src={url} alt="profile" className={className} />;
};

export default Avatar;
